import Api from 'api';
import * as TYPES from '../_types';
import Cookies from 'universal-cookie';

const update_firebase = (cart_items) => {

  const cookies = new Cookies();

  const firebase_api = new Api();

  const session = cookies.get('session_data') || {};

  firebase_api.update_cart(session.fid, cart_items);

}

const update_cart_items = (empty,cart=[],item={}) => (!!empty) ? [...cart, item] :
  cart.map(a => (a.handle !== item.handle) ? a : {...a , quantity: a.quantity+1});

const Add_To_Cart = (state, product) => {

  const cart = [...state.cart_items];

  const item = cart.filter(a => (a.handle === product.handle));

  const toggle_item = item.empty() ? {...product} : {...item[0]};

  const new_cart_items = update_cart_items(item.empty(), [...cart], toggle_item);

  const updated_cart_state = { ...state, cart_items: [...new_cart_items] };

  update_firebase(new_cart_items);

  return updated_cart_state;

};

/*const ToggleCartItem = (state,item) => {
  const cart = state.items;
  const ItemExists = cart.filter(a => (a.code === item.code)).length>0;
  const newState = (ItemExists) ? RemoveFromCart(state,item.code) : AddToCart(state,item);
  return GetButtonCaption(newState,item.code);
};*/

const RemoveFromCart = (state, handle) => {
  const new_cart_items = state.cart_items.filter(a => (a.handle !== handle));
  update_firebase(new_cart_items);
  return {...state, cart_items: [...new_cart_items] };
};

const SetCartItemQuantity = (state, { handle, quantity }) => {
  const _cart = state.cart_items.map(a=>(a.handle!==handle)?a:{...a,quantity:quantity});
  const new_state = {...state, cart_items: _cart };
  update_firebase(_cart);
  return new_state;
};

/*const DecreaseItemQuantity = (state,payload) => {
  const newState = {...state, items: cart.map(a => (a.code !== payload.code) ? a :
    {...a , quantity: a.quantity--})};
  return GetButtonCaption(newState,payload.code);
};

const AddChoiceToCart = (state,payload) => {
  const CartItems = state.items;
  const NewCartItems = CartItems.map(a => (a.code !== payload.code) ? a : payload);
  const newState = {...state, items: NewCartItems};
  const  = firebasedb.doc(payload.code).set(payload);
   catch(err => Alert.toast(err.message));
  return GetButtonCaption(newState,payload.code);
};*/

const LoadCartFromFireBase = (state,payload) => {
  if (payload.length===0) return state;
  return {...state, cart_items: payload}
}

const INITIAL_STATE = {
  cart_items: [],
}

export default (state=INITIAL_STATE, { type, payload }) => {

  switch (type) {

    //case 'CAPTION' : return GetButtonCaption(state, payload);

    case TYPES.UPDATE_CART : return LoadCartFromFireBase(state, payload);

    case TYPES.ADD_TO_CART : return Add_To_Cart(state, payload);

    //case 'TOGGLE_CART' : return ToggleCartItem(state, payload)

    case TYPES.REMOVE_FROM_CART : return RemoveFromCart(state,  payload);

    case TYPES.UPDATE_CART_ITEM : return SetCartItemQuantity(state, payload);

    //case 'ADD_CHOICE_TO_CART' : return AddChoiceToCart(state, payload);

    //case 'DECREASE_QUANTITY' : return DecreaseItemQuantity(state, payload);

    default : return state;

  }

}
